import React from 'react';
import PropTypes from 'prop-types';
import { AlertCircle, CheckCircle, Info, XCircle } from 'lucide-react';

const variants = {
  info: {
    container: 'bg-blue-50 border-blue-100 text-blue-800 dark:bg-blue-950/20 dark:border-blue-900/50 dark:text-blue-300',
    icon: <Info className="w-5 h-5 text-blue-500 flex-shrink-0" />,
    role: 'status'
  },
  success: {
    container: 'bg-emerald-50 border-emerald-100 text-emerald-800 dark:bg-emerald-950/20 dark:border-emerald-900/50 dark:text-emerald-300',
    icon: <CheckCircle className="w-5 h-5 text-emerald-500 flex-shrink-0" />,
    role: 'status'
  },
  warning: {
    container: 'bg-amber-50 border-amber-100 text-amber-800 dark:bg-amber-950/20 dark:border-amber-900/50 dark:text-amber-300',
    icon: <AlertCircle className="w-5 h-5 text-amber-500 flex-shrink-0" />,
    role: 'alert'
  },
  danger: {
    container: 'bg-rose-50 border-rose-100 text-rose-800 dark:bg-rose-950/20 dark:border-rose-900/50 dark:text-rose-300',
    icon: <XCircle className="w-5 h-5 text-rose-500 flex-shrink-0" />,
    role: 'alert'
  }
};

const Alert = ({ 
  children, 
  variant = 'info', 
  title, 
  icon = null,
  className = '', 
  ...props 
}) => {
  const activeVariant = variants[variant] || variants.info;
  const displayIcon = icon || activeVariant.icon;

  return (
    <div 
      role={activeVariant.role}
      className={`p-4 border-2 rounded-2xl flex items-start gap-3.5 ${activeVariant.container} ${className}`}
      {...props}
    >
      {displayIcon}
      <div className="min-w-0 flex-1">
        {title && <h4 className="font-bold text-sm mb-1">{title}</h4>}
        <div className="text-xs font-semibold leading-relaxed">{children}</div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['info', 'success', 'warning', 'danger']),
  title: PropTypes.string,
  icon: PropTypes.element,
  className: PropTypes.string
};

export default Alert;
